import React from "react";
import { isSelectedField } from "../../utils/cl_apply_utility";
import { updateStandardDataLayerAttributes, setNewBankAccountDataLayer } from "../../analytics/adobe/index";

class SelectedDueDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enrollAutoPay: false,
      notEnrollAutoPay: false,
      isAutoPayEnrollEnabled: 0,
      showDiv: false,
      radio: {
        yes: false,
        no: false
      },
      isStateChanged: false
    };

  }
  componentWillMount() {
    let depo =this.props.offerPreFilled.loanBankInfo.depositAccountDetails;
    let repay =this.props.offerPreFilled.loanBankInfo.repaymentAccountDetails;
    let validAcc= (isSelectedField(depo, "accountNumber") && isSelectedField(repay, "accountNumber"));
    this.onChange(this.props.offerPreFilled.loanBankInfo.isAutoPayEnrollEnabled?1:2, validAcc, true);
    let checked = null;
    if(validAcc){
      if(this.props.offerPreFilled.loanBankInfo.isAutoPayEnrollEnabled){
        checked ={ yes: true, no: false };
      }else{
        checked ={ yes: false, no: true };
      }
      this.setState({ radio: { ...checked } });

    }
    this.setState({ isStateChanged: (this.props.history.action === "PUSH") });
  }
  enableContinueBtn =() => {
    if(this.state.radio.yes === true || this.state.radio.no == true) {
      if(this.props.dropdownSelected !== "Select account" && this.props.dropdownSelectedLoan !== "Select account") {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

    onChange = (val, isValid, isDefault) => {
      let isStateChanged={};
      if(!isDefault){
        isStateChanged={ isStateChanged: true };
      }
      this.setState({
        notEnrollAutoPay: (val == 2),
        showDiv: (val == 1),
        enrollAutoPay: (val == 1),
        isAutoPayEnrollEnabled: val,
        radio: {
          yes: (isValid?(val == 1):false),
          no: (isValid?(val == 2):false)
        },
        ...isStateChanged
      });
      this.props.handleRepeatPaymentSelection(val === 1);
    }

    onSubmit=()=>{
      let expectedBankAccount= this.props.bankAccountInfo.bankAccountDetails.length>0?this.props.bankAccountInfo.bankAccountDetails[0].accountNumber:null;
      let checkNewAccountAdded = (expectedBankAccount === this.props.depositAcc.accountNumber || expectedBankAccount === this.props.makeAcc);
      let accountChangeStatus = checkNewAccountAdded ? 'New Bank Account': 'Existing Bank Account';
      let autoPaymentStatus= this.state.isAutoPayEnrollEnabled == 1? 'Turned on':'Turned off';
      updateStandardDataLayerAttributes(setNewBankAccountDataLayer(accountChangeStatus, autoPaymentStatus), false);
      this.props.errorHandle(false, false);
      let authorizationConsent = this.state.isAutoPayEnrollEnabled === 1? new Date().toJSON() : "";
      this.props.validateRoutingNumber({
        authorizationConsent: authorizationConsent,
        depositAccountDetails: this.props.depositAcc,
        repaymentAccountDetails: this.props.makeAcc,
        isAutoPayEnrollEnabled: (this.state.isAutoPayEnrollEnabled == 1),
        accountList: this.props.bankAccountInfo.bankAccountDetails,
        isStateChanged: this.state.isStateChanged||this.props.isStateChanged
      }, { mover: this.props.history, nextPage: "/clapply/action/customizeOffer/bankDetailsConfirm" }, this.props.errorHandle);
      this.setState({ isStateChanged: false }, this.props.resetState);
    }

  render = () => {
    const { showDiv } = this.state;
    return (
      <div className="repeatPayDiv">
        <div className="your-loan-details margin-bottom-10 margin-t-25">
                  Would you like to enroll in automatic payments?
        </div>
        <ul className="list-group cl-list rdio-margin-left repeatPayBody">
          <li className="d-flex h-40">
            <span className="badge">
              <div className="rdio rdio-primary radio-inline">
                <input name="radio" value="1" id="enroll" type="radio" checked={this.state.radio.yes}
                  onChange={() => { this.onChange(1, true); }}
                  aria-labelledby="yesRadioButton"
                />
                <label htmlFor="enroll"></label>
              </div>

            </span>
            <div className="p-5-10" id="yesRadioButton">

              <span className="your-loan-details-radio">Yes</span>
            </div>
          </li>

          <li className="d-flex h-40">

            <span className="badge">
              <div className="rdio rdio-primary radio-inline">
                <input name="radio" value="2" id="noEnroll" type="radio" checked={this.state.radio.no}
                  onChange={() => { this.onChange(2, true); }}
                  aria-labelledby="noRadioButton"
                />
                <label htmlFor="noEnroll"></label>
              </div>

            </span>
            <div className="p-5-10" id="noRadioButton">

              <span className="your-loan-details-radio">No</span>
            </div>
          </li>
        </ul>
        { showDiv && (
          <p className="display-text-small rdio-text font-weight-400">
            By selecting "Continue," you are authorizing Barclays to initiate a recurring electronic withdrawal
            to pay your loan on your payment due date, for the monthly due amount,
            from the "Make loan payments from" bank account listed above. It will be reflected on your bank account
            as an ACH withdrawal. <br/>
            This authorization will remain in effect until I cancel or modify my AutoPay Enrollment.
            I can cancel or modify my AutoPay Enrollment by visiting MyBarclaysUSLoan.com before 6 p.m. ET
            on the scheduled withdrawal date. Barclays can cancel these scheduled payments at any time.
          </p>
        )}
        <section className="col-12 text-btn-center add-bank m-m-15">
          <button type="submit" data-track="custom-links" className="btn-continue-padding button-override-color" disabled={this.enableContinueBtn()}
            onClick={this.onSubmit}
            aria-label="click to continue to the next page">Continue</button>
        </section>
        <p className="display-text-small font-weight-400">Upon submission, your credit information will be reviewed,
          which may affect your credit score.</p>
      </div>
    );
  }
}
export default SelectedDueDate;
